import { devConfigs } from "./dev.configs";
import { prodConfigs } from "./prod.configs";

export const configs = window.location.origin === "http://localhost:3000" ? devConfigs : prodConfigs;